/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M488.522 400.958l-68.317.939s-14.688 2.903-34.073-10.418c-25.62-17.592-49.673-63.109-68.431-57.273-19.044 6.035-18.418 47.053-18.418 47.053s.086 8.768-4.184 13.436c-4.668 5.124-13.948 6.149-13.948 6.149h-30.63s-67.49 4.07-127.07-57.9C58.779 275.568 1.392 141.609 1.392 141.609s-3.33-8.739.314-13.009c4.07-4.81 15.001-5.123 15.001-5.123l73.1-.513s6.888 1.139 11.898 4.782c4.042 3.046 6.348 8.569 6.348 8.569s11.87 29.888 27.498 56.96c30.6 52.803 44.776 64.274 55.194 58.752 15.116-8.227 10.618-74.694 10.618-74.694s.313-24.053-7.6-34.898c-6.149-8.312-17.592-10.703-22.716-11.443-4.156-.513 2.619-10.106 11.358-14.376 13.123-6.461 36.464-6.774 63.848-6.575 21.463.228 27.612 1.565 35.952 3.558 25.192 6.035 16.652 29.576 16.652 86.023 0 18.019-3.216 43.552 9.793 51.864 5.636 3.644 19.27.54 53.629-57.7 16.253-27.583 28.437-60.09 28.437-60.09s2.704-5.836 6.774-8.227c4.27-2.505 9.906-1.765 9.906-1.765l76.971-.512s23.114-2.733 26.872 7.686c3.956 10.93-8.654 36.578-40.108 78.536-51.665 68.744-57.387 62.283-14.49 102.191 40.934 38.002 49.474 56.533 50.84 58.839 16.88 28.323-18.958 30.515-18.958 30.515"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconVkAlt = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconVkAlt.defaultProps = {
  theme,
};
IconVkAlt.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconVkAlt.displayName = 'IconVkAlt';
export { IconVkAlt };
